import React, { useState, useEffect, memo } from "react";
import AnatomyOptions from "./AnatomyOptions";
import AnatomyForm from "./AnatomyForm";
import {
  rSetEnquiryId,
  rSetMuscleCode,
  rSetSubCategory,
} from "../../redux/reducers/GlobalVariables";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Button,
  Typography,
  CardActionArea,
  Skeleton,
  CardMedia,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, Category } from "@mui/icons-material";
import config from "../../services/config";
import { useNavigate } from "react-router-dom";
import { hideLoader, showLoader } from "../../redux/reducers/loaderSlice";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useMediaQuery } from "@mui/material";
import AnatomyPopup from "./AnatomyPopup";
import CategoryIcon from "@mui/icons-material/Category";

// Store images in an array
const gemImages = [
  `${process.env.PUBLIC_URL}/images/gem0.png`,
  `${process.env.PUBLIC_URL}/images/gem1.png`,
  `${process.env.PUBLIC_URL}/images/gem2.png`,
  `${process.env.PUBLIC_URL}/images/gem3.png`,
  `${process.env.PUBLIC_URL}/images/gem4.png`,
  `${process.env.PUBLIC_URL}/images/gem5.png`,
  `${process.env.PUBLIC_URL}/images/gem6.png`,
  `${process.env.PUBLIC_URL}/images/gem7.png`,
  `${process.env.PUBLIC_URL}/images/gem8.png`,
];

const Anatomy2 = () => {
  //#region code
  const isMobile = useMediaQuery("(max-width: 760px)");
  const { category, appointment } = useSelector(
    (state) => state.GlobalVariables
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageIndex, setImageIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [imageName, setImageName] = useState();
  const [activeSection, setActiveSection] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  const handleActiveSection = (params) => {
    try {
      setActiveSection(params);
    } catch (e) {
      console.log(e);
    }
  };

  const handleOpen = (params) => {
    try {
      handlePopupClose();
      // dispatch(rSetMuscleCode(params));
      setOpen(true);
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    try {
      setImageIndex((prev) => (prev + 1) % gemImages.length);
    } catch (e) {
      console.log(e);
    }
  };

  const handlePrevious = () => {
    try {
      setImageIndex((prev) => (prev - 1 + gemImages.length) % gemImages.length);
    } catch (e) {
      console.log(e);
    }
  };
  const [loading, setLoading] = useState(false);
  const fetchActiveSubCategory = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        category: category,
      };
      const res = await config.getActiveGroup(dataToSend);
      if (res.status === 200) {
        setSubCategory(res.data);
      } else {
        setSubCategory([]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveSubCategory();
    dispatch(rSetMuscleCode(null));
    dispatch(rSetEnquiryId(null));
  }, []);

  useEffect(() => {
    fetchActiveSubCategory();
  }, [category]);

  useEffect(() => {
    const result = "gem" + [imageIndex];
    setImageName(result);
    handleActiveSection("");
  }, [imageIndex]);

  const handleSubmit = async (params) => {
    try {
      dispatch(showLoader());
      const res = await config.createEnquiry(params);
      if (res.status === 200) {
        const enquiry_id = res.enquiry_id;
        dispatch(rSetEnquiryId(enquiry_id));
      }
      navigate("/symptoms");
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleGroup = (id) => {
    console.log("handleGroup", id);
    try {
      setOpenPopup(false);
      dispatch(rSetSubCategory(id));
      dispatch(rSetMuscleCode(id));
      if (appointment) {
        navigate("/appointment");
      } else {
        setOpenPopup(true);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // console.log("appointment===", appointment);
  const handlePopupClose = () => {
    setOpenPopup(false);
    // dispatch(rSetMuscleCode(null));
  };

  //#endregion

  return (
    <>
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
          p: 4,
        }}
      >
        <AnatomyPopup
          open={openPopup}
          handleClose={handlePopupClose}
          handleOpen={handleOpen}
        />
        {appointment ? (
          <Typography
            variant="h3"
            sx={{ color: "white", textAlign: "center", mt: 2 }}
          >
            Select Pain Area to continue booking
          </Typography>
        ) : (
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ color: "white", textAlign: "center" }}
          >
            How GoPT Can Help You?
          </Typography>
        )}
        <section className="services">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 3,
              py: 4,
            }}
          >
            {loading
              ? [...Array(6)].map((_, index) => (
                  <Card
                    key={index}
                    sx={{
                      width: 320,
                      p: 2,
                      borderRadius: 3,
                      boxShadow: 4,
                    }}
                  >
                    <Skeleton variant="rectangular" width="100%" height={150} />
                    <Skeleton variant="text" sx={{ mt: 2 }} />
                    <Skeleton variant="text" width="80%" />
                  </Card>
                ))
              : subCategory.map((item, index) => (
                  <Card
                    key={index}
                    sx={{
                      width: 320,
                      p: 3,
                      borderRadius: 4,
                      boxShadow: 6,
                      transition: "0.3s",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: 8,
                      },
                    }}
                  >
                    <CardActionArea onClick={() => handleGroup(item.id)}>
                      <CardMedia
                        component="img"
                        height="150"
                        image={
                          item.category_image && item.category_image.length > 0
                            ? item.category_image
                            : `${process.env.PUBLIC_URL}/images/pcl.jpg`
                        }
                        alt={item.group_name}
                        sx={{ borderRadius: "8px" }}
                      />
                      <CardContent>
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          textAlign="center"
                          sx={{
                            background:
                              "linear-gradient(45deg, #ff6b6b, #ffa502, #1e90ff, #ff4757)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            display: "block",
                          }}
                        >
                          {item.group_name}
                        </Typography>
                        <Button
                          variant="contained"
                          fullWidth
                          sx={{
                            mt: 2,
                            borderRadius: 2,
                            background:
                              "linear-gradient(45deg, #ff6b6b, #ffa502)",
                            color: "white",
                            "&:hover": {
                              background:
                                "linear-gradient(45deg, #ff4757, #ff9f1a)",
                            },
                          }}
                          onClick={() => handleGroup(item.id)}
                        >
                          Learn More
                        </Button>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
          </Box>
        </section>
        ;
      </Box>

      <AnatomyForm
        open={open}
        handleClose={handleClose}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default memo(Anatomy2);
